







































































































import {Component, Prop, Watch, Mixins, Vue} from 'vue-property-decorator'
import {$} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import CargaCollection from '@/model/collection/CargaCollection'
import DeliveryRequest from '@/model/request/DeliveryRequest'
import FilterDelivery from '@/components/filters/FilterDelivery.vue'
import {AppConfig} from '@/config/app.config'
import * as Helper from '@/helpers'
import FilterToggle from '@/components/FilterToggle.vue'
import TransitionExpand from 'simpli-web-sdk/lib/components/utils/TransitionExpand'
import ListReportParam from '@/model/request/ListReportParam'
import {TipoRelatorio} from '@/enums/TipoRelatorio'
import ModalConfirmEditCarga from '@/components/modals/ModalConfirmEditCarga.vue'
import ModalScheduledReport from '@/components/modals/ModalScheduledReport.vue'
import Responsavel from '@/model/resource/Responsavel'
import {Getter} from 'vuex-class'
import {MixinSelect} from '@/components/mixins/MixinSelect'
import Carga from '@/model/resource/Carga'
import ModalDeliveryRemove from '@/components/modals/ModalDeliveryRemove.vue'
import ModalAudit from '@/components/modals/ModalAudit.vue'
import ModalCargaFinalizadaParaNaoIniciada from '@/components/modals/ModalCargaFinalizadaParaNaoIniciada.vue'

const metaInfo = () => ({
  title: $.t('view.deliveryList.title'),
})

@Component({
  metaInfo,
  components: {
    ModalCargaFinalizadaParaNaoIniciada,
    ModalAudit,
    ModalScheduledReport,
    ModalConfirmEditCarga,
    TransitionExpand,
    FilterDelivery,
    FilterToggle,
    ModalDeliveryRemove,
  },
})
export default class DeliveryListView extends Mixins(MixinFilter, MixinSelect) {
  @Getter('auth/responsavel') user!: Responsavel

  AppConfig = AppConfig

  Helper = Helper

  filter = new DeliveryRequest()
  collection = new CargaCollection(this.filter)
  shown = ['slaStatus', 'sigla', 'insumo', 'tipoFinalizacao', 'tipoCriacao', 'auditGeo', 'documentResponsavelEmb',
    'documentResponsavelTransp', 'dataEntregaInicio', 'dataEntregaFim', 'dataPrevisaoInicio',
    'dataPrevisaoFim', 'manifesto', 'placaVeiculo', 'nomeDestinatario']

  startMode = false

  selectedItems: Carga[] = []

  async created() {
    this.collection.endpoint = '/user/carga/v2'
    if (Helper.getRegraExibicaoGrupoEconomico() && this.$route.query.forcar !== 'true') {
      this.populateOnMount = false
      this.startMode = true
    }

    if (this.$route.query.limpar !== 'false') {
      if (!this.filter.isDataFilterCleared) {
        this.$router.push('/delivery/list')
      }

      this.filter.cleanDateFilters()
    }

    this.collection.orderBy = 'dataFinalizacao'
    this.collection.asc = false

    if (this.$route.query.start === undefined && this.$route.query.dataEntregaInicio === undefined
        && !Helper.getRegraExibicaoGrupoEconomico()) {
      this.filter.startDate = DeliveryRequest.defaultStartOfDay()
    }
  }

  reloadContent() {
    this.query()
  }

  async downloadData(xlsx: boolean, simplified = false) {
    this.validateFilterDate()

    let idTipoRelatorio: TipoRelatorio
    if (xlsx) {
      if (simplified) {
        idTipoRelatorio = TipoRelatorio.DELIVERY_SIMPLE_XLSX
      } else {
        idTipoRelatorio = TipoRelatorio.DELIVERY_FULL_XLSX
      }
    } else {
      if (simplified) {
        idTipoRelatorio = TipoRelatorio.DELIVERY_SIMPLE_CSV
      } else {
        idTipoRelatorio = TipoRelatorio.DELIVERY_FULL_CSV
      }
    }

    const fetch = async () => {
      const request = new ListReportParam()

      Object.assign(request, this.filter)
      request.idTipoRelatorio = idTipoRelatorio

      const resp = await request.generateReport()

      if (resp.data) {
        this.$modal.open('ModalScheduledReport')
      } else {
        Helper.info('system.info.pleaseWaitForReport')
      }
    }
    await $.await.run(fetch, 'download')
  }

  validateFilterDate() {
    const dataCriacao = this.filter.startDate || this.filter.endDate
    const dataEntrega = this.filter.dataEntregaInicio || this.filter.dataEntregaFim
    const dataPrevisao = this.filter.dataPrevisaoInicio || this.filter.dataPrevisaoFim

    if (!dataCriacao && !dataEntrega && !dataPrevisao) {
      Helper.abort(this.$tc('view.deliveryList.dateFilterCantBeEmpty'))
    } else {
      if (dataCriacao) {
        if (!this.filter.startDate && this.filter.endDate) {
          Helper.abort(this.$tc('view.deliveryList.startFilterCantBeEmpty'))
        } else if (this.filter.startDate && !this.filter.endDate) {
          Helper.abort(this.$tc('view.deliveryList.endFilterCantBeEmpty'))
        }
      }
      if (dataEntrega) {
        if (!this.filter.dataEntregaInicio && this.filter.dataEntregaFim) {
          Helper.abort(this.$tc('view.deliveryList.dataEntregaInicioCantBeEmpty'))
        } else if (this.filter.dataEntregaInicio && !this.filter.dataEntregaFim) {
          Helper.abort(this.$tc('view.deliveryList.dataEntregaFimCantBeEmpty'))
        }
      }
      if (dataPrevisao) {
        if (!this.filter.dataPrevisaoInicio && this.filter.dataPrevisaoFim) {
          Helper.abort(this.$tc('view.deliveryList.dataPrevisaoInicioCantBeEmpty'))
        } else if (this.filter.dataPrevisaoInicio && !this.filter.dataPrevisaoFim) {
          Helper.abort(this.$tc('view.deliveryList.dataPrevisaoFimCantBeEmpty'))
        }
      }
    }
  }

  onFilter() {
    this.startMode = false
    this.filtrate()
  }

  openModalDelivery(items?: Carga[]) {
    const selectedItems = items || (this.selectedItems as Carga[])
    this.$modal.open('deliveryRemove', selectedItems)
  }

  async refresh() {
    this.selectedResource = {}
    this.selectedItems = []
    await this.query()
  }
}
